// tabsSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TabState {
  openFirstTimeOnlyPopup: any;
  applicationStatus: string;
  summaryPageActiveTab: string; // state is for tab from viewsummary page
  selectedIndex: number;
  productName: string;
  selectDisbDetailIndex: number;
  quickHelpInfoRoute: string;
  tabType: string; // Add tabType to state
}

const initialState: TabState = {
  openFirstTimeOnlyPopup: {},
  applicationStatus: "",
  summaryPageActiveTab: "summary",
  selectedIndex: 0,
  productName: "",
  selectDisbDetailIndex: 0,
  quickHelpInfoRoute: "",
  tabType: "Term Loan", // Default value
};

const tabsSlice = createSlice({
  name: "tabs",
  initialState,
  reducers: {
    setOpenFirstTimeOnlyPopup: (state, action: PayloadAction<any>) => {
      state.openFirstTimeOnlyPopup = action.payload;
    },
    setApplicationStatus: (state, action: PayloadAction<string>) => {
      state.applicationStatus = action.payload;
    },
    setSummaryPageActiveTab: (state, action: PayloadAction<string>) => {
      state.summaryPageActiveTab = action.payload;
    },
    setSelectedIndex: (state, action: PayloadAction<number>) => {
      state.selectedIndex = action.payload;
    },
    setSelectDisbDetailIndex: (state, action: PayloadAction<number>) => {
      state.selectDisbDetailIndex = action.payload;
    },
    setProdcuctName: (state, action: PayloadAction<string>) => {
      state.productName = action.payload;
    },
    setQuickHelpInfoRoute: (state, action: PayloadAction<string>) => {
      state.quickHelpInfoRoute = action.payload;
    },
    setTabType: (state, action: PayloadAction<string>) => {
      state.tabType = action.payload;
    },
    hydrateTabType: (state, action: PayloadAction<string>) => {
      state.tabType = action.payload;
    },
  },
});

export const {
  setOpenFirstTimeOnlyPopup,
  setApplicationStatus,
  setSummaryPageActiveTab,
  setSelectedIndex,
  setProdcuctName,
  setSelectDisbDetailIndex,
  setQuickHelpInfoRoute,
  setTabType,
  hydrateTabType,
} = tabsSlice.actions;
export default tabsSlice.reducer;